var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 80,
    viewBox: "0 0 134 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4605 71.6039H33.4109C30.9767 71.6039 29.0992 69.4479 29.5794 67.0615C34.1629 44.2837 51.153 10.7265 108.934 16.9557C66.4359 16.9557 54.6101 48.4079 53.6388 67.4769C53.5237 69.7358 51.7223 71.6039 49.4605 71.6039Z",
    fill: "url(#speed_svg__paint0_linear_9773_32910)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "speed_svg__mask0_9773_32910",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 8,
    width: 20,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.471 8L107.03 13.3369L111.646 8.88515L109.696 14.9977L116.052 15.835L110.062 18.1203L113.371 23.6161L107.851 20.3533L105.621 26.3691L104.728 20.0152L98.6396 22.0211L103.046 17.3606L97.6826 13.846L104.07 14.3885L103.471 8Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#speed_svg__mask0_9773_32910)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#speed_svg__filter0_f_9773_32910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1573 -3.88316C9.42088 1.71453 8.75003 7.33328 7.98086 12.9204C7.27845 18.2472 10.8057 20.2972 22.5881 23.944C49.7008 32.3079 76.7816 41.1971 103.881 49.9372C108.568 51.4438 112.566 51.0946 112.809 49.1575C114.538 35.3807 116.268 21.5905 118.062 7.8348L10.1573 -3.88316Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#speed_svg__filter1_f_9773_32910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7623 29.2205C92.4051 29.6579 91.9961 29.75 91.4539 30.2162C90.3176 30.338 90.9557 31.1985 91.8367 31.407C93.0774 31.7007 93.1939 31.1089 93.9434 30.7705C95.2577 30.1772 96.0247 29.68 97.6207 29.2677C98.7935 28.9646 101.831 29.2538 103.124 29.4579C105.05 29.7619 106.098 27.8893 107.03 27.164C108.374 26.1188 108.908 24.9643 110.925 24.3101C112.923 23.6619 115.258 23.5755 117.453 23.3092C119.882 23.0146 121.683 22.7727 123.355 21.472C124.774 20.368 123.317 19.1192 122.647 18.126C121.988 17.1478 119.285 16.764 117.864 16.483C116.026 16.1193 114.752 16.3728 112.974 16.6308C110.994 16.918 109.673 18.3907 107.766 18.6673C106.251 18.8871 103.284 18.7289 102.363 19.705C100.546 21.631 99.827 23.5386 96.2254 24.4692C94.8519 24.8241 94.2487 26.6151 93.8875 27.4916C93.6039 28.1794 93.2497 28.6236 92.7623 29.2205Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#speed_svg__filter2_f_9773_32910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.544 19.0828C115.633 17.8584 127.022 15.0104 132.133 10.8584C129.151 7.42368 124.218 15.1337 121.236 11.699L110.337 14.3676C107.471 16.5858 105.95 16.0945 108.544 19.0828Z",
    fill: "#0A9F68"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#speed_svg__filter3_f_9773_32910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2595 46.3377C28.9759 46.7403 29.0446 47.1771 28.7519 47.5995C28.4591 48.0218 27.6188 49.1319 27.728 49.3703C27.8859 49.7148 27.6653 50.3612 28.5055 50.4846C29.3175 50.604 30.4555 50.2544 31.3045 50.0538C34.4205 49.3173 37.421 48.1625 40.4301 47.2365C41.9518 46.7682 43.5769 46.5451 45.1419 46.1188C45.9046 45.9111 46.2468 45.6091 47.1095 45.5C47.938 45.3952 48.7067 45.1478 49.4933 44.9335C51.397 44.415 53.2034 44.335 55.1878 44.1284C57.3784 43.9002 60.2212 42.9457 62.2117 42.2612C68.5728 40.0734 72.434 36.4259 77.3655 33.3262C79.2786 32.1237 80.794 30.7456 82.8848 29.6309C85.0871 28.4568 87.6183 27.7522 90.224 27.0424C94.6676 25.832 99.5963 24.5878 103.611 22.8249C105.472 22.008 107.074 21.1142 108.079 19.8583C109.162 18.5045 107.697 16.3968 105.929 15.6735C104.947 15.2719 102.666 15.3352 101.411 15.3752C100.081 15.4176 98.7545 15.5532 97.4279 15.7051C92.4745 16.2722 87.6186 17.9086 83.523 19.8334C78.3815 22.2497 72.9714 22.7005 67.227 24.0328C64.4711 24.6721 61.8482 25.5287 59.2427 26.3643C57.5156 26.9181 56.3006 28.2483 55.0284 29.0962C51.4539 31.4787 49.5522 34.3959 45.2742 36.3946C43.2881 37.3225 41.1821 38.2219 38.928 38.86C37.702 39.2071 35.8559 39.6985 34.9337 40.3624C33.2195 41.5966 30.992 42.9735 30.3349 44.516C30.0953 45.0785 29.6381 45.8 29.2595 46.3377Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#speed_svg__filter4_f_9773_32910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.483 48.6838C86.4531 48.9926 86.6299 49.3145 86.6011 49.6383C86.5723 49.9621 86.4573 50.8158 86.5936 50.9888C86.7906 51.2389 86.873 51.7265 87.3792 51.7885C87.8684 51.8484 88.3901 51.5487 88.7984 51.3698C90.2969 50.7131 91.5985 49.75 92.9774 48.9563C93.6748 48.5549 94.5073 48.3319 95.2421 47.9602C95.6001 47.7791 95.6946 47.5428 96.1395 47.4314C96.5668 47.3244 96.9156 47.1136 97.2849 46.9267C98.1786 46.4746 99.1574 46.3514 100.195 46.128C101.34 45.8812 102.618 45.0723 103.507 44.4939C106.349 42.6453 107.338 39.8016 109.097 37.3265C109.779 36.3665 110.184 35.29 110.993 34.3888C111.844 33.4395 113.028 32.8271 114.251 32.2082C116.337 31.1528 118.682 30.0552 120.355 28.6048C121.13 27.9327 121.737 27.2127 121.897 26.245C122.07 25.202 120.587 23.6892 119.375 23.2148C118.702 22.9515 117.454 23.079 116.769 23.153C116.043 23.2315 115.349 23.379 114.66 23.5386C112.086 24.1345 109.906 25.5207 108.24 27.094C106.148 29.0692 103.284 29.5949 100.513 30.7868C99.1842 31.3586 97.998 32.0871 96.8147 32.7993C96.0303 33.2714 95.7768 34.3017 95.3386 34.9759C94.1073 36.8706 93.9755 39.1032 92.2314 40.7378C91.4217 41.4967 90.5363 42.2386 89.4858 42.7919C88.9143 43.0928 88.044 43.5228 87.742 44.0482C87.1806 45.0248 86.3791 46.1255 86.5031 47.2937C86.5483 47.7196 86.523 48.2714 86.483 48.6838Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#speed_svg__filter5_f_9773_32910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4042 56.2074C90.583 59.2714 90.7578 62.3357 90.9348 65.4027C91.9217 62.7697 92.7018 59.9094 93.343 57.0759C93.9176 54.5315 94.4359 51.9005 95.4681 49.7153C96.3397 47.8687 97.5076 46.4689 98.7971 45.2564C99.9162 42.4112 101.722 42.5515 103.704 40.7213C105.187 39.3534 105.581 40.0189 107.237 39.5454C106.389 41.8776 109.103 37.9947 110.034 35.6941C110.416 34.7519 109.997 35.0428 110.488 34.221C110.833 33.648 110.608 32.6653 111.039 32.2414C113.009 30.3118 113.293 24.8838 115.398 23.2792C112.719 22.2083 112.074 25.8986 109.411 26.3674C107.262 31.752 103.592 35.1619 100.123 38.694C99.8373 38.9844 99.5469 39.2663 99.2543 39.5454L90.3627 53.5391C90.3405 54.4326 90.3538 55.3231 90.4042 56.2074Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#speed_svg__filter6_f_9773_32910)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.92,
    cy: 29.9332,
    rx: 3.90344,
    ry: 3.2146,
    fill: "#71BBFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "speed_svg__filter0_f_9773_32910",
    x: 3.89551,
    y: -7.88318,
    width: 118.167,
    height: 62.7565,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32910"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "speed_svg__filter1_f_9773_32910",
    x: 86.843,
    y: 12.3016,
    width: 41.1118,
    height: 23.1847,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32910"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "speed_svg__filter2_f_9773_32910",
    x: 103.213,
    y: 5.95471,
    width: 32.9199,
    height: 17.1281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32910"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "speed_svg__filter3_f_9773_32910",
    x: 23.7183,
    y: 11.3456,
    width: 88.731,
    height: 43.1633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32910"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "speed_svg__filter4_f_9773_32910",
    x: 82.4797,
    y: 19.0563,
    width: 43.4312,
    height: 36.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32910"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "speed_svg__filter5_f_9773_32910",
    x: 87.3523,
    y: 20.0852,
    width: 31.0459,
    height: 48.3175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_9773_32910"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "speed_svg__filter6_f_9773_32910",
    x: 100.017,
    y: 22.7186,
    width: 15.8069,
    height: 14.4292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32910"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "speed_svg__paint0_linear_9773_32910",
    x1: 94.4685,
    y1: 16.2668,
    x2: 70.2826,
    y2: 76.4508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgSpeed;